import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatPetBreedingApplyInfo, NatResidentPetBreedingApplyLocationState} from './NatResidentApplicationInterface'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import NatResidentPetBreedingApplyConfirm from './resident/NatResidentPetBreedingApplyConfirm'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {NatPutPetBreedingApplyRequest, NatPutPetBreedingApplyResponse} from '../repository/NatPutPetBreedingApply'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    condominiumRepo: NatCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<NatResidentPetBreedingApplyLocationState>
}

class NatResidentPetBreedingApplyConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const locationState: NatPetBreedingApplyInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName, applicantFirstName, petType, petBreed,
            havePetStartMonth, healthCenterDogLicense, rabiesPreventionInjectionCertification,
        } = locationState
        let request: Nullable<NatPutPetBreedingApplyRequest>

        request = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            petType: petType,
            petBreed: petBreed,
            havePetStartMonth: havePetStartMonth,
            healthCenterDogLicense: {
                fileName: healthCenterDogLicense?.fileName ?? null,
                fileData: healthCenterDogLicense?.fileData ?? null,
                fileNumber: healthCenterDogLicense?.fileNumber ?? null,
            },
            rabiesPreventionInjectionCertification: {
                fileName: rabiesPreventionInjectionCertification?.fileName ?? null,
                fileData: rabiesPreventionInjectionCertification?.fileData ?? null,
                fileNumber: rabiesPreventionInjectionCertification?.fileNumber ?? null,
            },
            confirmed: true,
        }

        if (!request) {
            return
        }

        try {
            const response: Nullable<NatPutPetBreedingApplyResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyPetBreedingApply.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentPetBreedingApplyLocationState = this.props.location.state
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/petBreeding/input`,
            {
                replace: true,
                state: JSON.parse(JSON.stringify(locationState)),
            },
        )
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentPetBreedingApplyConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>修正する</CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentPetBreedingApplyConfirmPage)
